import { createAsyncThunk } from "@reduxjs/toolkit";
import { sendRequestJSON } from "src/lib/axios";
import { toastMessage } from "../commonSlice";
import { logout } from "../auth/thunks";
import { HolidayAPIService } from "src/constants";
import { IUpsertHolidayPayload } from "./types";

// Fetch all holidays
export const fetchHolidayList = createAsyncThunk(
  "holiday/fetchHolidayList",
  async (_, { dispatch }) => {
    try {
      const response = await sendRequestJSON(null, HolidayAPIService.GET_ALL_HOLIDAYS, "get");

      if (response?.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response.result?.message || "Failed to fetch holidays",
          })
        );
        return [];
      }

      return response.result?.data?.data || [];
    } catch (error: any) {
      if (error?.response?.data === "jwt expired") {
        dispatch(logout());
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: error?.response?.data || "Something went wrong",
          })
        );
      }
      return [];
    }
  }
);

// Create / Update (Upsert)
export const upsertHoliday = createAsyncThunk(
  "holiday/upsertHoliday",
  async (payload: IUpsertHolidayPayload, { dispatch }) => {
    try {
      const response = await sendRequestJSON(payload, HolidayAPIService.UPSERT_HOLIDAY, "post");

      if (response?.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response?.result?.message || "Failed to save holiday",
          })
        );
        return null;
      }

      const result = response?.result?.data;

      dispatch(
        toastMessage({
          message: result?.message || "Holiday saved successfully",
        })
      );

      return result?.data;
    } catch (error: any) {
      if (error?.response?.data === "jwt expired") {
        dispatch(logout());
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: error?.response?.data || "Something went wrong",
          })
        );
      }
      return null;
    }
  }
);

// Soft Delete
export const deleteHoliday = createAsyncThunk(
  "holiday/deleteHoliday",
  async (id: number, { dispatch }) => {
    try {
      const response = await sendRequestJSON(null, HolidayAPIService.DELETE_HOLIDAY(id), "delete");

      if (response?.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response?.result?.message || "Unable to delete holiday",
          })
        );
        return null;
      }

      dispatch(
        toastMessage({
          message: "Holiday deleted successfully",
        })
      );

      return id;
    } catch (error: any) {
      if (error?.response?.data === "jwt expired") {
        dispatch(logout());
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: error?.response?.data || "Delete failed",
          })
        );
      }
      return null;
    }
  }
);
